import { render, staticRenderFns } from "./PayMethodItem.vue?vue&type=template&id=668e4c9b&"
import script from "./PayMethodItem.vue?vue&type=script&lang=ts&"
export * from "./PayMethodItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports